<!-- Loading state -->
<div *ngIf="isLoading" style="padding: 40px; text-align: center; color: #6b7280;">
  Loading order details...
</div>

<div class="main-wrapper" *ngIf="!isLoading && order">
  <div class="page-wrapper">
    <div class="content">

      <div class="order-view-content">

        <div class="order-title-row">
          <div>
            <h4 class="order-title">{{ order.orderNo }} &mdash; {{ order.customerName }}</h4>
            <div class="order-subtitle">
              {{ order.route }}
              <span class="dot">&middot;</span>
              <span class="badge order-type-badge" [ngClass]="order.orderType?.toLowerCase()">
                {{ order.orderType | titlecase }}
              </span>
            </div>
          </div>

          <div class="title-actions">
            <span class="badge status-badge" [ngClass]="statusBadgeClass()">{{ statusLabel() }}</span>
            <a href="javascript:void(0)" class="back-link" (click)="goBack()">Back</a>
          </div>
        </div>

        <!-- ══════════════════════════════════════
             SECTION 1: General Details
        ══════════════════════════════════════ -->
        <div class="card-section">
          <div class="section-header">
            <span class="step-badge">1</span>
            <h5>General Details</h5>
          </div>

          <div class="section-body">
            <div class="form-grid">

              <div class="form-field">
                <label>Order No.</label>
                <input type="text" class="form-control" [value]="order.orderNo" readonly />
              </div>

              <div class="form-field">
                <label>LR Number</label>
                <input
                  type="text"
                  class="form-control"
                  [ngClass]="{ 'editable': canEditLrNumber(), 'highlight-green': order.lrNumber }"
                  [readonly]="!canEditLrNumber()"
                  [(ngModel)]="order.lrNumber"
                  placeholder="--" />
              </div>

              <div class="form-field">
                <label>Customer</label>
                <input type="text" class="form-control" [value]="order.customerName" readonly />
              </div>

              <div class="form-field">
                <label>Order Type</label>
                <input type="text" class="form-control" [value]="order.orderType | titlecase" readonly />
              </div>

              <div class="form-field">
                <label>Vehicle Required At</label>
                <input type="text" class="form-control" [value]="order.vehicleRequiredAt" readonly />
              </div>

              <div class="form-field">
                <label>Status</label>
                <input type="text" class="form-control" [value]="statusLabel()" readonly />
              </div>

              <div class="form-field">
                <label>Bidding Status</label>
                <input type="text" class="form-control" [value]="order.biddingStatus || '--'" readonly />
              </div>

              <div class="form-field">
                <label>No. of Vehicles</label>
                <input type="text" class="form-control" [value]="order.numberOfVehicle" readonly />
              </div>

              <div class="form-field">
                <label>Assigned KAM</label>
                <!-- <input type="text" class="form-control" [value]="order.assignedKam" readonly /> -->
                <ng-select
                class="disabled padding-8px"
                [items]="kamList"
                bindLabel="name"
                bindValue="id"
                appendTo="body"
                placeholder="Select KAM"
                [(ngModel)]="order.assignedKam">
              </ng-select>
              </div>

              <div class="form-field">
                <label>Assigned Proc. Exec.</label>
                <ng-select
                  class="disabled padding-8px"
                  [items]="procurementExecList"
                  bindLabel="name"
                  bindValue="id"
                  appendTo="body"
                  [(ngModel)]="order.assignedProcExec"
                  placeholder="Select procurement executive">
                </ng-select>
                <!-- <input
                  type="text"
                  class="form-control"
                  [ngClass]="{ 'editable': canEditProcExec() }"
                  [readonly]="!canEditProcExec()"
                  [(ngModel)]="order.assignedProcExec" /> -->
              </div>

            </div>
          </div>

          <div class="section-footer" *ngIf="canEditGeneralDetails()">
            <button type="button" class="btn btn-purple" (click)="saveGeneralDetails()">Save</button>
          </div>
        </div>

        <!-- ══════════════════════════════════════
             SECTION 2: Pricing
        ══════════════════════════════════════ -->
        <div class="card-section" *ngIf="showPricingSection()">
          <div class="section-header" [ngClass]="{ 'between': showMarginBadge() }">
            <div class="d-flex align-items-center gap-2">
              <span class="step-badge">2</span>
              <h5>{{ pricingSectionTitle() }}</h5>
            </div>
            <span class="badge margin-badge" [ngClass]="marginBadgeClass()" *ngIf="showMarginBadge()">
              {{ marginPercent() }}% Margin
            </span>
          </div>

          <div class="section-body">

            <!-- Info banner -->
            <div class="info-banner" *ngIf="infoBannerText()">{{ infoBannerText() }}</div>

            <!-- Head approval pending banner -->
            <div class="approval-banner" *ngIf="showApprovalRequiredBanner()">
              <b>Approval Required.</b> KAM submitted a rate below adjusted procurement rate. Please review and enter approved amount.
            </div>


            <!-- ═══ ROLE_KAM VIEW ═══ -->
            <ng-container *ngIf="role === 'ROLE_KAM'">

              <!-- Contract -->
              <!-- <ng-container *ngIf="isContract()">
                <div class="contract-banner">
                  <b>Contract Order.</b>&nbsp; Rate: <b>{{ formatCurrency(order.confirmedAmount) }}</b>
                </div>
              </ng-container> -->

              <!-- Contract — KAM confirm/reject -->
              <ng-container *ngIf="isContract()">
                <div class="form-grid">
                  <div class="form-field">
                    <label>Customer Amount (₹)</label>
                    <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.customerAmount)" readonly />
                  </div>
                  <!-- <div class="form-field">
                    <label>Confirmed Amount (₹)</label>
                    <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.confirmedAmount)" readonly />
                  </div> -->
                  <!-- <div class="form-field">
                    <label>Procurement Rate (₹)</label>
                    <input type="text" class="form-control" [value]="formatCurrency(order.procurementProvidedAmount)" readonly />
                  </div> -->
                  <div class="form-field">
                    <label>Status</label>
                    <input type="text" class="form-control" [value]="statusLabel()" readonly />
                  </div>
                </div>

                <!-- HEAD_APPROVED — KAM confirm or reject -->
                <ng-container *ngIf="order.status === 'HEAD_APPROVED'">
                  <!-- <div class="form-grid mt-3">
                    <div class="form-field">
                      <label>Head Approved Amount (₹)</label>
                      <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.procHeadAmount)" readonly />
                    </div>
                  </div> -->
                  
                  <div class="section-footer no-border">
                    <button type="button" class="btn btn-outline-red" [disabled]="actionLoading" (click)="rejectOrder()">Reject</button>
                    <button type="button" class="btn btn-green" [disabled]="actionLoading" (click)="confirmOrder()">
                      {{ actionLoading ? 'Confirming...' : '✓ Confirm Order' }}
                    </button>
                  </div>
                </ng-container>
                

                <!-- ORDER_CONFIRMED -->
                <ng-container *ngIf="order.status === 'ORDER_CONFIRMED'">
                  <div class="info-banner" style="margin-top: 12px;">
                    ✓ Order confirmed
                     <!-- Final Amount: <b>{{ formatCurrency(order.confirmedAmount) }}</b> -->
                  </div>
                </ng-container>

                <!-- QUOTE_SHARED or any other status — KAM can enter counter rate -->
                <ng-container *ngIf="order.status !== 'ORDER_CONFIRMED' && order.status !== 'CREATED' && order.status !== 'HEAD_APPROVED' && order.status !== 'REJECTED'">
                  <div class="form-grid mt-3">
                    <div class="form-field">
                      <label>Final BD Rate (₹) <span class="required">*</span></label>
                      <input
                        type="number"
                        class="form-control editable"
                        placeholder="Enter final rate"
                        [(ngModel)]="finalBdRateInput" />
                      <small class="field-hint" *ngIf="finalBdRateInput && order.customerAmount">
                        <span *ngIf="finalBdRateInput < order.customerAmount" class="hint-warn">
                          ⚠ Less than procurement rate — will go to Head for approval
                        </span>
                        <span *ngIf="finalBdRateInput >= order.customerAmount" class="hint-ok">
                          ✓ Will be confirmed directly
                        </span>
                      </small>
                    </div>
                  </div>
                  <div class="section-footer no-border" *ngIf="order.status !== 'HEAD_PENDING'">
                    <button type="button" class="btn btn-outline-red" [disabled]="actionLoading" (click)="rejectOrder()">Reject</button>
                    <button type="button" class="btn btn-purple" [disabled]="actionLoading || !finalBdRateInput" (click)="submitFinalBdRate()">
                      {{ actionLoading ? 'Submitting...' : 'Submit' }}
                    </button>
                  </div>
                </ng-container>

              </ng-container>

              <!-- Spot — Rate Known -->
              <ng-container *ngIf="isSpot() && !order.isNullPrice">
                <div class="form-grid">
                  <div class="form-field">
                    <label>Customer Rate (₹)</label>
                    <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.customerAmount)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Confirmed Amount (₹)</label>
                    <input type="text" class="form-control" [value]="formatCurrency(order.confirmedAmount)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Price Status</label>
                    <input type="text" class="form-control highlight-green" [value]="statusLabel()" readonly />
                  </div>
                </div>

                <ng-container *ngIf="order.status === 'HEAD_APPROVED'">
                  <!-- <div class="form-grid mt-3">
                    <div class="form-field">
                      <label>Head Approved Amount (₹)</label>
                      <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.procHeadAmount)" readonly />
                    </div>
                  </div> -->
                  
                  <div class="section-footer no-border">
                    <button type="button" class="btn btn-outline-red" [disabled]="actionLoading" (click)="rejectOrder()">Reject</button>
                    <button type="button" class="btn btn-green" [disabled]="actionLoading" (click)="confirmOrder()">
                      {{ actionLoading ? 'Confirming...' : '✓ Confirm Order' }}
                    </button>
                  </div>
                </ng-container>
                

                <!-- ORDER_CONFIRMED -->
                <ng-container *ngIf="order.status === 'ORDER_CONFIRMED'">
                  <div class="info-banner" style="margin-top: 12px;">
                    ✓ Order confirmed
                     <!-- Final Amount: <b>{{ formatCurrency(order.confirmedAmount) }}</b> -->
                  </div>
                </ng-container>
                
                <!-- KAM enters Final BD Rate — only when NOT yet HEAD_APPROVED or ORDER_CONFIRMED -->
                <ng-container *ngIf="order.status !== 'ORDER_CONFIRMED' && order.status !== 'HEAD_APPROVED' && order.status !== 'REJECTED'">
                  <div class="form-grid mt-3">
                    <div class="form-field">
                      <label>Final BD Rate (₹) <span class="required">*</span></label>
                      <input
                        type="number"
                        class="form-control editable"
                        placeholder="Enter final BD rate"
                        [(ngModel)]="finalBdRateInput" />
                      <small class="field-hint" *ngIf="finalBdRateInput && order.adjustedProcRate">
                        <span *ngIf="finalBdRateInput < order.adjustedProcRate" class="hint-warn">
                          ⚠ Less than adjusted rate — will go to Head for approval
                        </span>
                        <span *ngIf="finalBdRateInput >= order.adjustedProcRate" class="hint-ok">
                          ✓ Will be confirmed directly
                        </span>
                      </small>
                    </div>
                  </div>

                  <div class="section-footer no-border">
                    <button
                      type="button"
                      class="btn btn-outline-red"
                      [disabled]="actionLoading"
                      (click)="rejectOrder()">
                      Reject
                    </button>
                    <button
                      type="button"
                      class="btn btn-purple"
                      [disabled]="actionLoading || !finalBdRateInput"
                      (click)="submitFinalBdRate()">
                      {{ actionLoading ? 'Submitting...' : 'Submit' }}
                    </button>
                  </div>
                </ng-container>
              </ng-container>

              <!-- Spot — NULL Price — enter Final BD Rate -->
              <ng-container *ngIf="isSpot() && order.isNullPrice">
                <div class="form-grid">
                  <!-- <div class="form-field">
                    <label>Procurement Rate (₹)</label>
                    <input type="text" class="form-control" [value]="formatCurrency(order.procurementProvidedAmount)" readonly />
                  </div> -->
                  <div class="form-field">
                    <label>Procurement Rate (₹)</label>
                    <input type="text" class="form-control highlight-yellow" [value]="formatCurrency(order.adjustedProcRate)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Confirmed Amount (₹)</label>
                    <input type="text" class="form-control" [value]="formatCurrency(order.confirmedAmount)" readonly />
                  </div>
                </div>

                <!-- KAM enters Final BD Rate — only when NOT yet HEAD_APPROVED or ORDER_CONFIRMED -->
                <ng-container *ngIf="order.status !== 'ORDER_CONFIRMED' && order.status !== 'HEAD_APPROVED' && order.status !== 'REJECTED'">
                  <div class="form-grid mt-3">
                    <div class="form-field">
                      <label>Final BD Rate (₹) <span class="required">*</span></label>
                      <input
                        type="number"
                        class="form-control editable"
                        placeholder="Enter final BD rate"
                        [(ngModel)]="finalBdRateInput" />
                      <small class="field-hint" *ngIf="finalBdRateInput && order.adjustedProcRate">
                        <span *ngIf="finalBdRateInput < order.adjustedProcRate" class="hint-warn">
                          ⚠ Less than adjusted rate — will go to Head for approval
                        </span>
                        <span *ngIf="finalBdRateInput >= order.adjustedProcRate" class="hint-ok">
                          ✓ Will be confirmed directly
                        </span>
                      </small>
                    </div>
                  </div>

                  <div class="section-footer no-border">
                    <button
                      type="button"
                      class="btn btn-outline-red"
                      [disabled]="actionLoading"
                      (click)="rejectOrder()">
                      Reject
                    </button>
                    <button
                      type="button"
                      class="btn btn-purple"
                      [disabled]="actionLoading || !finalBdRateInput"
                      (click)="submitFinalBdRate()">
                      {{ actionLoading ? 'Submitting...' : 'Submit' }}
                    </button>
                  </div>
                </ng-container>

                <!-- KAM sees HEAD_APPROVED — Confirm or Reject -->
                <ng-container *ngIf="order.status === 'HEAD_APPROVED'">
                  <div class="form-grid mt-3">
                    <div class="form-field">
                      <label>Head Approved Amount (₹)</label>
                      <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.procHeadAmount)" readonly />
                    </div>
                  </div>

                  <div class="section-footer no-border">
                    <button
                      type="button"
                      class="btn btn-outline-red"
                      [disabled]="actionLoading"
                      (click)="rejectOrder()">
                      Reject
                    </button>
                    <button
                      type="button"
                      class="btn btn-green"
                      [disabled]="actionLoading"
                      (click)="confirmOrder()">
                      {{ actionLoading ? 'Confirming...' : '✓ Confirm Order' }}
                    </button>
                  </div>
                </ng-container>

                <!-- ORDER_CONFIRMED -->
                <ng-container *ngIf="order.status === 'ORDER_CONFIRMED'">
                  <div class="form-grid mt-3">
                    <div class="form-field">
                      <label>Final Confirmed Amount (₹)</label>
                      <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.confirmedAmount)" readonly />
                    </div>
                  </div>
                </ng-container>

              </ng-container>

            </ng-container>

            <!-- ═══ ROLE_PROCUREMENT VIEW ═══ -->
            <ng-container *ngIf="role === 'ROLE_PROCUREMENT'">

              <ng-container *ngIf="isContract()">
                <div class="contract-banner">
                  <b>Contract Order.</b>&nbsp; Rate: <b>{{ formatCurrency(order.confirmedAmount) }}</b>
                </div>
              </ng-container>

              <ng-container *ngIf="isSpot() && !order.isNullPrice">
                <div class="form-grid">
                  <div class="form-field">
                    <label>Customer Rate (₹)</label>
                    <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.customerAmount)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Procurement Rate (₹)</label>
                    <input type="text" class="form-control" [(ngModel)]="order.procurementRate" placeholder="Enter procurement rate" />
                  </div>
                  <div class="form-field">
                    <label>Status</label>
                    <input type="text" class="form-control highlight-green" [value]="statusLabel()" readonly />
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="isSpot() && order.isNullPrice">
                <div class="form-grid">
                  <div class="form-field">
                    <label>Procurement Rate (₹)</label>
                    <input type="text" class="form-control" [(ngModel)]="order.procurementRate" placeholder="Enter procurement rate" />
                  </div>
                  <div class="form-field">
                    <label>Adjusted (KAM sees, +5%)</label>
                    <input type="text" class="form-control highlight-purple" [value]="formatCurrency(order.adjustedProcRate)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Status</label>
                    <input type="text" class="form-control" [value]="statusLabel()" readonly />
                  </div>
                </div>
              </ng-container>

            </ng-container>

            <!-- ═══ ROLE_PROCUREMENT_HEAD VIEW ═══ -->
            <ng-container *ngIf="role === 'ROLE_PROCUREMENT_HEAD'">

              <!-- Full pricing visibility -->
              <div class="form-grid">

                <div class="form-field">
                  <label>Customer Amount (₹)</label>
                  <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.customerAmount)" readonly />
                </div>

                <!-- <div class="form-field" *ngIf="isContract()">
                  <label>Contract Confirmed Amount (₹)</label>
                  <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.confirmedAmount)" readonly />
                </div>
                 -->
                <div class="form-field">
                  <label>Procurement Rate (₹)</label>
                  <input type="text" class="form-control" [value]="formatCurrency(order.procurementProvidedAmount)" readonly />
                </div>

                <div class="form-field">
                  <label>Adjusted Proc. Rate (₹)</label>
                  <input type="text" class="form-control highlight-purple" [value]="formatCurrency(order.adjustedProcRate)" readonly />
                </div>

                <!-- <div class="form-field">
                  <label>Confirmed Amount (₹)</label>
                  <input type="text" class="form-control" [value]="formatCurrency(order.confirmedAmount)" readonly />
                </div> -->

                <div class="form-field" *ngIf="order.procHeadAmount">
                  <label>Head Amount (₹)</label>
                  <input type="text" class="form-control highlight-yellow" [value]="formatCurrency(order.procHeadAmount)" readonly />
                </div>

                <div class="form-field">
                  <label>Status</label>
                  <input type="text" class="form-control" [value]="statusLabel()" readonly />
                </div>

              </div>

              <!-- HEAD enters approved amount — only when HEAD_PENDING -->
              <ng-container *ngIf="order.status === 'HEAD_PENDING'">
                <div class="form-grid mt-3">
                  <div class="form-field">
                    <label>Head Approved Amount (₹) <span class="required">*</span></label>
                    <input
                      type="number"
                      class="form-control editable"
                      placeholder="Enter approved amount"
                      [(ngModel)]="procHeadAmountInput" />
                  </div>

                  <div class="form-field">
                    <label>Select Vendor <span class="required">*</span></label>
                    <ng-select
                      [items]="vendorList"
                      bindLabel="vendorName"
                      bindValue="id"
                      [multiple]="false"
                      [searchable]="true"
                      appendTo="body"
                      placeholder="Search vendor..."
                      [(ngModel)]="selectedVendorId">
                      <ng-template ng-option-tmp let-item="item">
                        <div>
                          <div style="font-weight: 500; font-size: 0.9rem;">{{ item.vendorName }}</div>
                          <div style="font-size: 0.78rem; color: #888;">{{ item.email }}</div>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>

                <ng-container *ngIf="showApprovalRequiredBanner()">
                  <div
                    class="margin-card"
                    [ngClass]="{
                      'margin-profit': getMargin(order) >= 0,
                      'margin-loss': getMargin(order) < 0
                    }">
                
                    <div class="margin-header">MARGIN</div>
                
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <span class="margin-value">
                          ₹{{ getMargin(order) | number:'1.0-2' }}
                        </span>
                
                        <span class="margin-percent">
                          ({{ getMarginPercentage(order) | number:'1.0-2' }}%)
                        </span>
                      </div>
                
                      <div class="small">
                        ₹{{ order.customerAmount | number:'1.0-2' }}
                        -
                        ₹{{ order.procurementProvidedAmount | number:'1.0-2' }}
                      </div>
                    </div>
                  </div>
                </ng-container>

                <div class="section-footer no-border">
                  <button
                    type="button"
                    class="btn btn-outline-red"
                    [disabled]="actionLoading"
                    (click)="rejectOrder()">
                    Reject
                  </button>
                  <button
                    type="button"
                    class="btn btn-green"
                    [disabled]="actionLoading || !procHeadAmountInput || !selectedVendorId"
                    (click)="submitHeadApproval()">
                    {{ actionLoading ? 'Approving...' : '✓ Approve' }}
                  </button>
                </div>
              </ng-container>

              <!-- Already approved -->
              <ng-container *ngIf="order.status === 'HEAD_APPROVED'">
                <div class="info-banner" style="margin-top: 16px;">
                  ✓ You have approved this order with amount {{ formatCurrency(order.procHeadAmount) }}. Waiting for KAM confirmation.
                </div>
              </ng-container>

            </ng-container>

            <!-- ═══ ROLE_VENDOR VIEW ═══ -->
            <ng-container *ngIf="role === 'ROLE_VENDOR'">
              <div class="info-banner restricted-banner">
                <b>Vendor View.</b> Pricing details are not visible to your role.
              </div>
            </ng-container>

          </div>
        </div>

        <!-- Order Status Timeline -->
        <!-- <div class="card-section" *ngIf="order.orderStatus && order.orderStatus.length">
          <div class="section-header">
            <span class="step-badge">3</span>
            <h5>Order Status</h5>
          </div>
          <div class="section-body">
            <div class="status-timeline">
              <div class="status-item" *ngFor="let s of order.orderStatus">
                <div class="status-dot" [ngClass]="s.status === 'PENDING' ? 'dot-pending' : 'dot-done'"></div>
                <div class="status-info">
                  <span class="status-type">{{ s.statusType?.replace('_', ' ') | titlecase }}</span>
                  <span class="status-val" [ngClass]="s.status === 'PENDING' ? 'val-pending' : 'val-done'">{{ s.status }}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Bottom bar -->
        <div class="bottom-bar">
          <button type="button" class="btn btn-outline" (click)="goBack()">Back</button>
          <button *ngIf="role === 'ROLE_PROCUREMENT' && (order?.status === 'QUOTE_PENDING' || order?.status === 'CREATED')" class="btn btn-primary" (click)="openSubmitRate(order)">Submit Rate</button>
          <span class="badge status-badge" [ngClass]="statusBadgeClass()">{{ statusLabel() }}</span>
        </div>

      </div>
    </div>
  </div>
</div>



<!-- ═══════════════════════════════════════════════
     SUBMIT RATE 
════════════════════════════════════════════════ -->
<p-dialog
  [(visible)]="showSubmitRateDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '30vw' }"
  styleClass="submit-rate-dialog"
  (onHide)="closeSubmitRateDialog()">
 
  <!-- Dialog header -->
  <ng-template pTemplate="header">
    <div>
      <div style="font-weight: 600; font-size: 1rem;">Submit rate</div>
      <div style="font-size: 0.8rem; color: #888; margin-top: 2px;">{{ currentOrderForRate?.orderNumber }}</div>
    </div>
  </ng-template>
 
  <div *ngIf="submitRateStep === 'confirm'" class="confirm-step">
    <div class="radar-icon">
       <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.001 512.001" xml:space="preserve" width="50" height="50" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect x="330.25" y="129.857" style="fill:#FFE6B8;" width="121.095" height="176.824"></rect> <g> <path style="fill:#D35B38;" d="M454.327,93.624H327.269c-10.006,0-18.118,8.111-18.118,18.118l0,0 c0,10.006,8.111,18.118,18.118,18.118h127.058c10.006,0,18.118-8.111,18.118-18.118l0,0 C472.444,101.736,464.333,93.624,454.327,93.624z"></path> <path style="fill:#D35B38;" d="M454.327,306.685H327.269c-10.006,0-18.118,7.883-18.118,17.889l0,0 c0,10.006,8.111,18.118,18.118,18.118h127.058c10.006,0,18.118-8.111,18.118-18.118l0,0 C472.444,314.568,464.333,306.685,454.327,306.685z"></path> </g> <path style="fill:#FFAD61;" d="M465.972,382.37H315.624c-19.787,0-35.829,16.041-35.829,35.829l0,0c0,0.099,0.08,0.178,0.178,0.178 h221.65c0.099,0,0.178-0.08,0.178-0.178l0,0C501.801,398.411,485.76,382.37,465.972,382.37z"></path> <rect x="210.991" y="201.873" style="fill:#FFE6B8;" width="119.259" height="32.801"></rect> <path style="fill:#D35B38;" d="M210.991,243.845H35.772c-14.124,0-25.572-11.449-25.572-25.571l0,0 c0-14.123,11.449-25.572,25.572-25.572h175.219V243.845z"></path> <g> <path style="fill:#4D3D36;" d="M465.972,372.17H315.624c-25.38,0-46.028,20.648-46.028,46.028c0,5.722,4.655,10.378,10.378,10.378 h221.65c5.722,0,10.378-4.655,10.378-10.378C512,392.819,491.352,372.17,465.972,372.17z M292.034,408.178 c3.909-9.167,13.011-15.609,23.59-15.609h150.349c10.579,0,19.68,6.441,23.589,15.609H292.034z"></path> <path style="fill:#4D3D36;" d="M320.051,244.871v52.543c-12.129,3.174-21.1,14.146-21.1,27.16 c0,15.614,12.703,28.317,28.317,28.317h127.058c15.615,0,28.318-12.703,28.318-28.317c0-13.014-8.971-23.986-21.1-27.16v-158.29 c12.129-3.199,21.1-14.262,21.1-27.382c0-15.615-12.703-28.318-28.318-28.318H327.269c-15.614,0-28.317,12.703-28.317,28.318 c0,13.12,8.971,24.182,21.1,27.382v52.551h-98.913c-0.515-5.151-4.861-9.173-10.147-9.173H35.772 C16.046,182.503,0,198.549,0,218.274s16.046,35.771,35.772,35.771h175.219c5.286,0,9.633-4.023,10.147-9.173H320.051z M340.449,140.06h100.696v156.426H340.449V140.06z M454.327,316.885c4.441,0,7.92,3.378,7.92,7.69c0,4.366-3.552,7.919-7.92,7.919 H327.269c-4.366,0-7.919-3.551-7.919-7.919c0-4.313,3.479-7.69,7.919-7.69H454.327z M327.269,119.662 c-4.366,0-7.919-3.552-7.919-7.92s3.552-7.92,7.919-7.92h127.058c4.366,0,7.92,3.552,7.92,7.92s-3.552,7.92-7.92,7.92H327.269z M320.051,224.473H221.19v-12.398h98.861V224.473z M20.398,218.274c0-8.477,6.897-15.372,15.373-15.372h165.02v30.745H35.772 C27.295,233.646,20.398,226.749,20.398,218.274z"></path> <path style="fill:#4D3D36;" d="M421.227,286.598c5.633,0,10.199-4.567,10.199-10.199v-60.175c0-5.632-4.566-10.199-10.199-10.199 s-10.199,4.567-10.199,10.199v60.175C411.028,282.031,415.594,286.598,421.227,286.598z"></path> <path style="fill:#4D3D36;" d="M421.227,197.865c5.633,0,10.199-4.567,10.199-10.199v-3.06c0-5.632-4.566-10.199-10.199-10.199 s-10.199,4.567-10.199,10.199v3.06C411.028,193.298,415.594,197.865,421.227,197.865z"></path> </g> </g></svg>
    </div>
    <h5 class="confirm-title">Initiate vendor bidding?</h5>
    <p class="confirm-subtitle">
      Would you like to invite vendors to bid on this order before submitting your rate?
    </p>
    <button type="button" class="btn btn-primary btn-block" (click)="onYesInvite()">
      Invite vendors
    </button>
    <button type="button" class="btn btn-cancel btn-block mt-2" (click)="onNoJustSubmit()">
      Submit rate
    </button>
  </div>
 
  <!-- ── Rate + Vendor form ── -->
  <div *ngIf="submitRateStep === 'form'" [formGroup]="rateForm">
 
    <!-- Rate -->
    <div class="mb-3">
      <label class="form-label">Your rate (₹) <span style="color:red">*</span></label>
      <input
        type="number"
        class="form-control"
        placeholder="Enter amount"
        formControlName="rate" />
      <small class="text-danger" *ngIf="isRateInvalid('rate')">Rate is required</small>
    </div>
 
    <!-- Vendors -->
    <div class="mb-3">
      <label class="form-label">Select vendors <span style="color:red">*</span></label>
 
      <!-- Multiple when inviteVendors = true -->
      <ng-select
        *ngIf="inviteVendors"
        [items]="vendorList"
        bindLabel="vendorName"
        bindValue="id"
        [multiple]="true"
        [closeOnSelect]="false"
        appendTo="body"
        placeholder="Search vendors..."
        formControlName="vendors">

        <!-- Select All header -->
        <ng-template ng-header-tmp>
            <div style="padding: 8px 12px; border-bottom: 1px solid #eee; display: flex; align-items: center; gap: 8px; cursor: pointer;"
            (click)="toggleSelectAll()">
            <input
                type="checkbox"
                [checked]="isAllSelected()"
                [indeterminate]="isSomeSelected()"
                style="width: 15px; height: 15px; cursor: pointer;"
                (click)="$event.stopPropagation()" />
            <span style="font-size: 0.88rem; font-weight: 500; color: #374151;">Select all</span>
            </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
            <div>
            <div style="font-weight: 500; font-size: 0.9rem;">{{ item.vendorName }}</div>
            <div style="font-size: 0.78rem; color: #888;">{{ item.email }}</div>
            </div>
        </ng-template>
        </ng-select>
 
      <!-- Single when inviteVendors = false -->
      <ng-select
        *ngIf="!inviteVendors"
        [items]="vendorList"
        bindLabel="vendorName"
        bindValue="id"
        [multiple]="false"
        appendTo="body"
        placeholder="Search vendors..."
        formControlName="vendors">
        <ng-template ng-option-tmp let-item="item">
          <div>
            <div style="font-weight: 500; font-size: 0.9rem;">{{ item.vendorName }}</div>
            <div style="font-size: 0.78rem; color: #888;">{{ item.email }}</div>
          </div>
        </ng-template>
      </ng-select>
      <small class="text-danger" *ngIf="isRateInvalid('vendors')">Please select at least one vendor</small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <ng-container *ngIf="submitRateStep === 'confirm'"></ng-container>
    <div *ngIf="submitRateStep === 'form'" class="d-flex justify-content-between w-100">
      <button type="button" class="btn btn-cancel" (click)="onRateBack()">
        ‹ Back
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="rateForm.invalid"
        (click)="onSubmitRate()">
        <span *ngIf="inviteVendors">Send &amp; initiate bidding</span>
        <span *ngIf="!inviteVendors">Submit rate</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
 